import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Layout from "../components/Layout.vue";
import ErrorPage from "@/components/404.vue"; // @ is an alias to /src
import usePiniaStore from "@/store/index";

// 菜单栏的页面meta.form = 菜单栏页面的name
// 非菜单栏的页面meta.form = 所属菜单栏页面的name
export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home/person-center",
  },
  {
    path: "/home",
    component: Layout,
    children: [
      {
        path: "person-center",
        name: "person-center",
        component: () =>
          import(
            /* webpackChunkName: "person-center" */ "../views/person-center/index.vue"
          ),
        meta: {
          title: "个人中心",
          hidden: true,
        },
      },
      {
        path: "app-upload",
        name: "app-upload",
        component: () =>
          import(
            /* webpackChunkName: "person-center" */ "../views/person-center/app-upload.vue"
          ),
        meta: {
          title: "上传app",
          hidden: true,
        },
      },
      {
        path: "no-permission",
        name: "no-permission",
        component: () =>
          import(
            /* webpackChunkName: "person-center" */ "../views/person-center/no-permission.vue"
          ),
        meta: {
          title: "访问受限",
          hidden: true,
        },
      },
      {
        path: "price-rule-demo",
        name: "price-rule-demo",
        component: () =>
          import(
            /* webpackChunkName: "price-rule-demo" */ "../views/price-rule-demo/index.vue"
          ),
        meta: {
          title: "价格配置 Demo",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/app-download",
    name: "/app-download",
    component: () =>
      import(
        /* webpackChunkName: "person-center" */ "../views/person-center/app-download.vue"
      ),
    meta: {
      title: "下载app",
    },
  },
  {
    path: "/login",
    name: "login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/index.vue"),
    meta: {
      title: "个人登录",
    },
  },
  {
    path: "/print-preview",
    name: "/print-preview",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "print-preview" */ "../views/print-preview/index.vue"
      ),
    meta: {
      title: "报表预览",
    },
  },

  {
    path: "/account-management",
    name: "/account-management",
    component: Layout,
    meta: {
      title: "账号管理",
      icon: "account",
      roles: ["account_management"],
    },
    children: [
      {
        path: "account-list",
        name: "account-list",
        component: () =>
          import(
            /* webpackChunkName: "account-list" */ "../views/account-management/account-list.vue"
          ),
        meta: {
          title: "账号",
          roles: ["account_management_list"],
          from: "account-list",
        },
      },
      {
        path: "account-detail",
        name: "account-detail",
        component: () =>
          import(
            /* webpackChunkName: "account-list" */ "../views/account-management/account-detail.vue"
          ),
        meta: {
          title: "账号信息",
          roles: ["account_management_list"],
          from: "account-list",
          hidden: true,
        },
      },
      {
        path: "account-add",
        name: "account-add",
        component: () =>
          import(
            /* webpackChunkName: "account-list" */ "../views/account-management/account-add.vue"
          ),
        meta: {
          title: "新增账号",
          roles: ["account_management_list"],
          from: "account-list",
          hidden: true,
        },
      },
      {
        path: "role-list",
        name: "role-list",
        component: () =>
          import(
            /* webpackChunkName: "role-list" */ "../views/account-management/role-list.vue"
          ),
        meta: {
          title: "角色",
          roles: ["account_management_list"],
          from: "role-list",
        },
      },
      {
        path: "role-detail",
        name: "role-detail",
        component: () =>
          import(
            /* webpackChunkName: "role-list" */ "../views/account-management/role-detail.vue"
          ),
        meta: {
          title: "角色信息",
          roles: ["account_management_list"],
          from: "role-list",
          hidden: true,
        },
      },
      {
        path: "role-add",
        name: "role-add",
        component: () =>
          import(
            /* webpackChunkName: "role-list" */ "../views/account-management/role-add.vue"
          ),
        meta: {
          title: "新增角色",
          roles: ["account_management_list"],
          from: "role-list",
          hidden: true,
        },
      },
      {
        path: "permission-list",
        name: "permission-list",
        component: () =>
          import(
            /* webpackChunkName: "permission-list" */ "../views/account-management/permission-list.vue"
          ),
        meta: {
          title: "权限",
          roles: ["account_management_list"],
          from: "permission-list",
        },
      },
    ],
  },
  {
    path: "/sales-management",
    name: "/sales-management",
    component: Layout,
    meta: {
      title: "车票销售",
      icon: "sale",
      roles: ["sales_management"],
    },
    children: [
      {
        path: "ticket-sale",
        name: "ticket-sale",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/ticket-sale.vue"
          ),
        meta: {
          title: "门店出票",
          roles: ["sales_management_list"],
          from: "ticket-sale",
        },
      },
      {
        path: "trip-preview",
        name: "trip-preview",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/trip-preview.vue"
          ),
        meta: {
          title: "查询售票",
          roles: ["ticket_management_trip_overview"],
          from: "trip-preview",
        },
      },

      {
        path: "sale-exchange",
        name: "sale-exchange",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/sale-exchange.vue"
          ),
        meta: {
          title: "open票销售",
          roles: ["open_management_sale"],
          from: "sale-exchange",
        },
      },

      {
        path: "fetch-ticket",
        name: "fetch-ticket",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/fetch-ticket.vue"
          ),
        meta: {
          title: "取位留位",
          roles: ["sales_management_ticket_fetch_booking"],
          from: "fetch-ticket",
        },
      },
      {
        path: "booking-ticket-list",
        name: "booking-ticket-list",
        component: () =>
          import(
            /* webpackChunkName: "sales-management-booking" */ "../views/sales-management/booking-ticket-list.vue"
          ),
        meta: {
          title: "留位销售",
          roles: ["sales_management_ticket_fetch_booking"],
          from: "booking-ticket-list",
        },
      },
      {
        path: "booking-ticket-details",
        name: "booking-ticket-details",
        component: () =>
          import(
            /* webpackChunkName: "sales-management-booking" */ "../views/sales-management/booking-ticket-details.vue"
          ),
        meta: {
          title: "预留订单详情",
          roles: ["sales_management_ticket_fetch_booking"],
          from: "booking-ticket-details",
          hidden: true,
        },
      },
      {
        path: "ticket-charter",
        name: "ticket-charter",
        component: () =>
          import(
            /* webpackChunkName: "ticket-charter" */ "../views/sales-management/ticket-charter.vue"
          ),
        meta: {
          title: "包车票销售",
          roles: ["sales_management_ticket_charter"],
          from: "ticket-charter",
        },
      },

      {
        path: "handwrite-ticket-sale",
        name: "handwrite-ticket-sale",
        component: () =>
          import(
            /* webpackChunkName: "sales-management" */ "../views/sales-management/handwrite-ticket-sale.vue"
          ),
        meta: {
          title: "手写票销售",
          roles: ["sales_management_handwrite_ticket"],
          from: "handwrite-ticket-sale",
        },
      },
      {
        path: "touch-screen-ticket",
        name: "touch-screen-ticket",
        component: () =>
          import(
            /* webpackChunkName: "touch-screen-ticket" */ "../views/touch-screen-ticket/index.vue"
          ),
        meta: {
          title: "机场售票",
          roles: ["sales-management_touch_screen_ticket"],
          from: "touch-screen-ticket",
        },
      },
    ],
  },
  {
    path: "/order-tickets-management",
    name: "/order-tickets-management",
    component: Layout,
    meta: {
      title: "订单车票管理",
      icon: "document",
      roles: ["order_tickets_management"],
    },
    children: [
      {
        path: "order-list-finance",
        name: "order-list-finance",
        component: () =>
          import(
            /* webpackChunkName: "order-list-finance" */ "../views/order-tickets-management/order-list-finance.vue"
          ),
        meta: {
          title: "订单查询",
          roles: ["order_tickets_management_order"],
          from: "order-list-finance",
        },
      },
      {
        path: "order-list-finance-detail",
        name: "order-list-finance-detail",
        component: () =>
          import(
            /* webpackChunkName: "order-list-finance" */ "../views/order-tickets-management/order-list-finance-detail.vue"
          ),
        meta: {
          title: "订单详情",
          roles: ["order_tickets_management_order"],
          from: "order-list-finance",
          hidden: true,
        },
      },

      {
        path: "order-list-store",
        name: "order-list-store",
        component: () =>
          import(
            /* webpackChunkName: "order-list-store" */ "../views/order-tickets-management/order-list-store.vue"
          ),
        meta: {
          title: "门市订单查询",
          roles: ["order_tickets_management_order_store"],
          from: "order-list-store",
        },
      },
      {
        path: "order-list-store-detail",
        name: "order-list-store-detail",
        component: () =>
          import(
            /* webpackChunkName: "order-list-store" */ "../views/order-tickets-management/order-list-store-detail.vue"
          ),
        meta: {
          title: "订单详情",
          roles: ["order_tickets_management_order_store"],
          from: "order-list-store",
          hidden: true,
        },
      },
      {
        path: "ticket-inquiry",
        name: "ticket-inquiry",
        component: () =>
          import(
            /* webpackChunkName: "ticket-inquiry" */ "../views/order-tickets-management/ticket-inquiry.vue"
          ),
        meta: {
          title: "车票查询",
          roles: ["order_tickets_management_tickets"],
          from: "ticket-inquiry",
        },
      },
      {
        path: "ticket-inquiry-details",
        name: "ticket-inquiry-details",
        component: () =>
          import(
            /* webpackChunkName: "ticket-inquiry" */ "../views/order-tickets-management/ticket-inquiry-details.vue"
          ),
        meta: {
          title: "车票详情",
          roles: ["order_tickets_management_tickets"],
          from: "ticket-inquiry",
          hidden: true,
        },
      },
      {
        path: "package-ticket-detail",
        name: "package-ticket-detail",
        component: () =>
          import(
            /* webpackChunkName: "ticket-inquiry" */ "../views/order-tickets-management/package-ticket-detail.vue"
          ),
        meta: {
          title: "补价票/行李票详情",
          roles: ["order_tickets_management_tickets"],
          from: "ticket-inquiry",
          hidden: true,
        },
      },
      {
        path: "ticket-rebook",
        name: "ticket-rebook",
        component: () =>
          import(
            /* webpackChunkName: "ticket-rebook" */ "../views/order-tickets-management/ticket-rebook.vue"
          ),
        meta: {
          title: "车票改签",
          roles: ["order_tickets_management"],
          from: "ticket-rebook",
          hidden: true,
        },
      },
      {
        path: "quick-search-ticket",
        name: "quick-search-ticket",
        component: () =>
          import(
            /* webpackChunkName: "quick-search-ticket" */ "../views/order-tickets-management/quick-search-ticket.vue"
          ),
        meta: {
          title: "快速查票",
          roles: ["quick-search-ticket"],
          from: "quick-search-ticket",
          target: "_blank",
        },
      },
      {
        path: "message-list",
        name: "message-list",
        component: () =>
          import(
            /* webpackChunkName: "message-list" */ "../views/order-tickets-management/message-list/index.vue"
          ),
        meta: {
          title: "短信邮件",
          roles: ["order_tickets_management_message"],
          from: "message-list",
        },
      },
      {
        path: "add-message",
        name: "add-message",
        component: () =>
          import(
            /* webpackChunkName: "add-message" */ "../views/order-tickets-management/add-message/index.vue"
          ),
        meta: {
          title: "新增短信",
          roles: ["order_tickets_management_message"],
          from: "message-list",
          hidden: true,
        },
      },
      {
        path: "message-details",
        name: "message-details",
        component: () =>
          import(
            /* webpackChunkName: "message-details" */ "../views/order-tickets-management/message-details.vue"
          ),
        meta: {
          title: "短信详情",
          roles: ["order_tickets_management_message"],
          from: "message-list",
          hidden: true,
        },
      },
      {
        path: "ticket-charter-list",
        name: "ticket-charter-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-charter" */ "../views/order-tickets-management/ticket-charter-list.vue"
          ),
        meta: {
          title: "包车票管理",
          roles: ["order_tickets_management_ticket_charter"],
          from: "ticket-charter-list",
        },
      },
      {
        path: "ticket-charter-detail",
        name: "ticket-charter-detail",
        component: () =>
          import(
            /* webpackChunkName: "ticket-charter" */ "../views/order-tickets-management/ticket-charter-detail.vue"
          ),
        meta: {
          title: "包车票",
          roles: ["order_tickets_management_ticket_charter"],
          from: "ticket-charter-list",
          hidden: true,
        },
      },
      {
        path: "ticket-charter-order-list",
        name: "ticket-charter-order-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-charter" */ "../views/order-tickets-management/ticket-charter-order-list.vue"
          ),
        meta: {
          title: "包车单管理",
          roles: ["order_tickets_management_ticket_charter_order"],
          from: "ticket-charter-order-list",
        },
      },
      {
        path: "ticket-charter-order-detail",
        name: "ticket-charter-order-detail",
        component: () =>
          import(
            /* webpackChunkName: "ticket-charter" */ "../views/order-tickets-management/ticket-charter-order-detail.vue"
          ),
        meta: {
          title: "包车单详情",
          roles: ["order_tickets_management_ticket_charter_order"],
          from: "ticket-charter-order-list",
          hidden: true,
        },
      },
      {
        path: "batch-operate-tickets",
        name: "batch-operate-tickets",
        component: () =>
          import(
            /* webpackChunkName: "batch-operate-tickets" */ "../views/order-tickets-management/batch-operate-tickets.vue"
          ),
        meta: {
          title: "批量操作车票",
          roles: ["order_tickets_management_batch_operate"],
          from: "batch-operate-tickets",
        },
      },
    ],
  },
  {
    path: "/agent-management",
    name: "/agent-management",
    component: Layout,
    meta: {
      title: "代理管理",
      icon: "place",
      roles: ["agent_management"],
    },
    children: [
      {
        path: "agent-management-list",
        name: "agent-management-list",
        component: () =>
          import(
            /* webpackChunkName: "agent-management-list" */ "../views/agent-management/agent-management-list.vue"
          ),
        meta: {
          title: "代理信息",
          roles: ["agent_management_list"],
          from: "agent-management-list",
        },
      },
      {
        path: "general-agent-detail",
        name: "general-agent-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-management-list" */ "../views/agent-management/general-agent-detail.vue"
          ),
        meta: {
          title: "总代理详情",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "add-general-agent",
        name: "add-general-agent",
        component: () =>
          import(
            /* webpackChunkName: "agent-management-list" */ "../views/agent-management/add-general-agent.vue"
          ),
        meta: {
          title: "新增总代理",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "sub-agent-check-list",
        name: "sub-agent-check-list",
        component: () =>
          import(
            /* webpackChunkName: "sub-agent-check-list" */ "../views/agent-management/sub-agent-check-list.vue"
          ),
        meta: {
          title: "子代理列表",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "sub-agent-detail",
        name: "sub-agent-detail",
        component: () =>
          import(
            /* webpackChunkName: "sub-agent-check-list" */ "../views/agent-management/sub-agent-detail.vue"
          ),
        meta: {
          title: "子代理详情",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "add-sub-agent",
        name: "add-sub-agent",
        component: () =>
          import(
            /* webpackChunkName: "sub-agent-check-list" */ "../views/agent-management/add-sub-agent.vue"
          ),
        meta: {
          title: "新增子代理",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "general-agent-cash-recharge-detail",
        name: "general-agent-cash-recharge-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-management" */ "../views/agent-management/general-agent-cash-recharge-detail.vue"
          ),
        meta: {
          title: "总代理增值详情",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "stock-list-add",
        name: "stock-list-add",
        component: () =>
          import(
            /* webpackChunkName: "agent-management" */ "../views/agent-management/stock-list-add.vue"
          ),
        meta: {
          title: "增值记录新增",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "stock-list-detail",
        name: "stock-list-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-management" */ "../views/agent-management/stock-list-detail.vue"
          ),
        meta: {
          title: "增值记录详情",
          roles: ["agent_management_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },

      {
        path: "agent-account-list",
        name: "agent-account-list",
        component: () =>
          import(
            /* webpackChunkName: "agent-account-list" */ "../views/agent-management/agent-account-list.vue"
          ),
        meta: {
          title: "代理登录账号",
          roles: ["agent_management_account_list"],
          from: "agent-account-list",
        },
      },
      {
        path: "agent-yushen-add",
        name: "agent-yushen-add",
        component: () =>
          import(
            /* webpackChunkName: "agent-yushen-add" */ "../views/agent-management/agent-yushen-add.vue"
          ),
        meta: {
          title: "生成预审单",
          roles: ["agent_management_account_list"],
          from: "agent-management-list",
          hidden: true,
        },
      },
      {
        path: "agent-account-detail",
        name: "agent-account-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-account-list" */ "../views/agent-management/agent-account-detail.vue"
          ),
        meta: {
          title: "账号详情",
          roles: ["agent_management_account_list"],
          from: "agent-account-list",
          hidden: true,
        },
      },
      {
        path: "agent-account-add",
        name: "agent-account-add",
        component: () =>
          import(
            /* webpackChunkName: "agent-account-list" */ "../views/agent-management/agent-account-add.vue"
          ),
        meta: {
          title: "新增账号",
          roles: ["agent_management_account_list"],
          from: "agent-account-list",
          hidden: true,
        },
      },
      {
        path: "agent-api-list",
        name: "agent-api-list",
        component: () =>
          import(
            /* webpackChunkName: "agent-api-list" */ "../views/agent-management/agent-api-list.vue"
          ),
        meta: {
          title: "API账号",
          roles: ["agent-api-list"],
          from: "agent-api-list",
        },
      },
      {
        path: "agent-api-add",
        name: "agent-api-add",
        component: () =>
          import(
            /* webpackChunkName: "agent-api-add" */ "../views/agent-management/agent-api-add.vue"
          ),
        meta: {
          title: "新增API代理账号",
          roles: ["agent-api-list"],
          from: "agent-api-list",
          hidden: true,
        },
      },
      {
        path: "agent-api-detail",
        name: "agent-api-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-api-detail" */ "../views/agent-management/agent-api-detail.vue"
          ),
        meta: {
          title: "API账号详情",
          roles: ["agent-api-list"],
          from: "agent-api-list",
          hidden: true,
        },
      },
      {
        path: "agent-white-list",
        name: "agent-white-list",
        component: () =>
          import(
            /* webpackChunkName: "agent-white-list" */ "../views/agent-management/agent-white-list.vue"
          ),
        meta: {
          title: "API白名单",
          roles: ["agent-white-list"],
          from: "agent-white-list",
        },
      },
      {
        path: "agent-white-add",
        name: "agent-white-add",
        component: () =>
          import(
            /* webpackChunkName: "agent-white-add" */ "../views/agent-management/agent-white-add.vue"
          ),
        meta: {
          title: "新增API白名单",
          roles: ["agent-white-list"],
          from: "agent-white-list",
          hidden: true,
        },
      },
      {
        path: "agent-white-detail",
        name: "agent-white-detail",
        component: () =>
          import(
            /* webpackChunkName: "agent-white-detail" */ "../views/agent-management/agent-white-detail.vue"
          ),
        meta: {
          title: "API白名单详情",
          roles: ["agent-white-list"],
          from: "agent-white-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/ticket-management",
    name: "/ticket-management",
    component: Layout,
    meta: {
      title: "票务管理",
      icon: "ticket",
      roles: ["ticket_management"],
    },
    children: [
      {
        path: "city-list",
        name: "city-list",
        component: () =>
          import(
            /* webpackChunkName: "city-management" */ "../views/ticket-management/city-list.vue"
          ),
        meta: {
          title: "城市",
          roles: ["ticket_management_city"],
          from: "city-list",
        },
      },
      {
        path: "city-add",
        name: "city-add",
        component: () =>
          import(
            /* webpackChunkName: "city-management" */ "../views/ticket-management/city-add.vue"
          ),
        meta: {
          title: "新增城市",
          roles: ["ticket_management_city"],
          from: "city-list",
          hidden: true,
        },
      },
      {
        path: "city-detail",
        name: "city-detail",
        component: () =>
          import(
            /* webpackChunkName: "city-management" */ "../views/ticket-management/city-detail.vue"
          ),
        meta: {
          title: "城市详情",
          roles: ["ticket_management_city"],
          from: "city-list",
          hidden: true,
        },
      },
      {
        path: "area-list",
        name: "area-list",
        component: () =>
          import(
            /* webpackChunkName: "area-management" */ "../views/ticket-management/area-list.vue"
          ),
        meta: {
          title: "展示区域",
          roles: ["ticket_management_area"],
          from: "area-list",
        },
      },
      {
        path: "area-add",
        name: "area-add",
        component: () =>
          import(
            /* webpackChunkName: "area-management" */ "../views/ticket-management/area-add.vue"
          ),
        meta: {
          title: "新增展示区域",
          roles: ["ticket_management_area"],
          from: "area-list",
          hidden: true,
        },
      },
      {
        path: "area-detail",
        name: "area-detail",
        component: () =>
          import(
            /* webpackChunkName: "area-management" */ "../views/ticket-management/area-detail.vue"
          ),
        meta: {
          title: "展示区域详情",
          roles: ["ticket_management_area"],
          from: "area-list",
          hidden: true,
        },
      },
      {
        path: "priceArea-list",
        name: "priceArea-list",
        component: () =>
          import(
            /* webpackChunkName: "price-management" */ "../views/ticket-management/priceArea-list.vue"
          ),
        meta: {
          title: "价格区域",
          roles: ["ticket_management_priceArea"],
          from: "priceArea-list",
        },
      },
      {
        path: "priceArea-detail",
        name: "priceArea-detail",
        component: () =>
          import(
            /* webpackChunkName: "price-management" */ "../views/ticket-management/priceArea-detail.vue"
          ),
        meta: {
          title: "价格区域详情",
          roles: ["ticket_management_priceArea"],
          from: "priceArea-list",
          hidden: true,
        },
      },
      {
        path: "priceArea-add",
        name: "priceArea-add",
        component: () =>
          import(
            /* webpackChunkName: "price-management" */ "../views/ticket-management/priceArea-add.vue"
          ),
        meta: {
          title: "新增价格区域",
          roles: ["ticket_management_priceArea"],
          from: "priceArea-list",
          hidden: true,
        },
      },
      {
        path: "station-list",
        name: "station-list",
        component: () =>
          import(
            /* webpackChunkName: "station-management" */ "../views/ticket-management/station-list.vue"
          ),
        meta: {
          title: "站点",
          roles: ["ticket_management_station"],
          from: "station-list",
        },
      },
      {
        path: "station-add",
        name: "station-add",
        component: () =>
          import(
            /* webpackChunkName: "station-management" */ "../views/ticket-management/station-add.vue"
          ),
        meta: {
          title: "新增站点",
          roles: ["ticket_management_station"],
          from: "station-list",
          hidden: true,
        },
      },
      {
        path: "station-detail",
        name: "station-detail",
        component: () =>
          import(
            /* webpackChunkName: "station-management" */ "../views/ticket-management/station-detail.vue"
          ),
        meta: {
          title: "站点详情",
          roles: ["ticket_management_station"],
          from: "station-list",
          hidden: true,
        },
      },
      {
        path: "basic-route-list",
        name: "basic-route-list",
        component: () =>
          import(
            /* webpackChunkName: "basic-route-management" */ "../views/ticket-management/basic-route-list.vue"
          ),
        meta: {
          title: "路线",
          roles: ["ticket_management_basic_route"],
          from: "basic-route-list",
        },
      },
      {
        path: "basic-route-add",
        name: "basic-route-add",
        component: () =>
          import(
            /* webpackChunkName: "basic-route-management" */ "../views/ticket-management/basic-route-add.vue"
          ),
        meta: {
          title: "新增路线",
          roles: ["ticket_management_basic_route"],
          from: "basic-route-list",
          hidden: true,
        },
      },
      {
        path: "basic-route-detail",
        name: "basic-route-detail",
        component: () =>
          import(
            /* webpackChunkName: "basic-route-management" */ "../views/ticket-management/basic-route-detail.vue"
          ),
        meta: {
          title: "路线详情",
          roles: ["ticket_management_basic_route"],
          from: "basic-route-list",
          hidden: true,
        },
      },
      {
        path: "transfer-station-list",
        name: "transfer-station-list",
        component: () =>
          import(
            /* webpackChunkName: "transfer-station" */ "../views/ticket-management/transfer-station-list.vue"
          ),
        meta: {
          title: "中转站",
          roles: ["transfer_station_management_list"],
          from: "transfer-station-list",
        },
      },
      {
        path: "transfer-station-add",
        name: "transfer-station-add",
        component: () =>
          import(
            /* webpackChunkName: "transfer-station" */ "../views/ticket-management/transfer-station-add.vue"
          ),
        meta: {
          title: "新增中转站",
          roles: ["transfer_station_management_list"],
          from: "transfer-station-list",
          hidden: true,
        },
      },
      {
        path: "line-list",
        name: "line-list",
        component: () =>
          import(
            /* webpackChunkName: "line-management" */ "../views/ticket-management/line-list.vue"
          ),
        meta: {
          title: "行程",
          roles: ["ticket_management_line"],
          from: "line-list",
        },
      },
      {
        path: "line-add",
        name: "line-add",
        component: () =>
          import(
            /* webpackChunkName: "line-management" */ "../views/ticket-management/line-add.vue"
          ),
        meta: {
          title: "新增行程",
          roles: ["ticket_management_line"],
          from: "line-list",
          hidden: true,
        },
      },
      {
        path: "line-detail",
        name: "line-detail",
        component: () =>
          import(
            /* webpackChunkName: "line-management" */ "../views/ticket-management/line-detail.vue"
          ),
        meta: {
          title: "行程详情",
          roles: ["ticket_management_line"],
          from: "line-list",
          hidden: true,
        },
      },
      {
        path: "trip-list",
        name: "trip-list",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/trip-list.vue"
          ),
        meta: {
          title: "班次",
          roles: ["ticket_management_trip"],
          from: "trip-list",
        },
      },
      {
        path: "trip-add",
        name: "trip-add",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/trip-add.vue"
          ),
        meta: {
          title: "新增班次",
          roles: ["ticket_management_trip"],
          from: "trip-list",
          hidden: true,
        },
      },
      {
        path: "trip-detail",
        name: "trip-detail",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/trip-detail.vue"
          ),
        meta: {
          title: "班次详情",
          roles: ["ticket_management_trip"],
          from: "trip-list",
          hidden: true,
        },
      },
      {
        path: "shuttle-service-list",
        name: "shuttle-service-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/shuttle-service-list.vue"
          ),
        meta: {
          title: "查询接驳",
          roles: ["ticket_management_shuttle_service_list"],
          from: "shuttle-service-list",
        },
      },
      {
        path: "split-trip-list",
        name: "split-trip-list",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/split-trip-list.vue"
          ),
        meta: {
          title: "班次拆分",
          roles: ["ticket_management_split_trip"],
          from: "split-trip-list",
        },
      },
      {
        path: "split-trip-detail",
        name: "split-trip-detail",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/split-trip-detail.vue"
          ),
        meta: {
          title: "班次拆分详情",
          roles: ["ticket_management_split_trip"],
          from: "split-trip-list",
          hidden: true,
        },
      },
      {
        path: "split-trip-add",
        name: "split-trip-add",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/split-trip-add.vue"
          ),
        meta: {
          title: "班次拆分新增",
          roles: ["ticket_management_split_trip"],
          from: "split-trip-list",
          hidden: true,
        },
      },
      {
        path: "merge-trip-list",
        name: "merge-trip-list",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/merge-trip-list.vue"
          ),
        meta: {
          title: "班次合并",
          roles: ["ticket_management_trip_merge"],
          from: "merge-trip-list",
        },
      },
      {
        path: "merge-trip-edit",
        name: "merge-trip-edit",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/merge-trip-edit.vue"
          ),
        meta: {
          title: "班次合并编辑",
          roles: ["ticket_management_trip_merge"],
          from: "merge-trip-list",
          hidden: true,
        },
      },
      {
        path: "limited-seats-list",
        name: "limited-seats-list",
        component: () =>
          import(
            /* webpackChunkName: "trip-management" */ "../views/ticket-management/limited-seats-list/index.vue"
          ),
        meta: {
          title: "班次余位预警",
          roles: ["ticket_management_limited_seats"],
          from: "limited-seats-list",
        },
      },
      {
        path: "limited-seats-add",
        name: "limited-seats-add",
        component: () =>
          import(
            /* webpackChunkName: "special-management" */ "../views/ticket-management/limited-seats-add.vue"
          ),
        meta: {
          title: "新增预警规则",
          roles: ["ticket_management_limited_seats"],
          from: "limited-seats-list",
          hidden: true,
        },
      },
      {
        path: "seat-list",
        name: "seat-list",
        component: () =>
          import(
            /* webpackChunkName: "seat-management" */ "../views/ticket-management/seat-list.vue"
          ),
        meta: {
          title: "座位模版",
          roles: ["ticket_management_seat"],
          from: "seat-list",
        },
      },
      {
        path: "seat-detail",
        name: "seat-detail",
        component: () =>
          import(
            /* webpackChunkName: "seat-management" */ "../views/ticket-management/seat-detail.vue"
          ),
        meta: {
          title: "模版详情",
          roles: ["ticket_management_seat"],
          from: "seat-list",
          hidden: true,
        },
      },
      {
        path: "seat-add",
        name: "seat-add",
        component: () =>
          import(
            /* webpackChunkName: "seat-management" */ "../views/ticket-management/seat-add.vue"
          ),
        meta: {
          title: "新增座位模版",
          roles: ["ticket_management_seat"],
          from: "seat-list",
          hidden: true,
        },
      },
      {
        path: "company-list",
        name: "company-list",
        component: () =>
          import(
            /* webpackChunkName: "company-management" */ "../views/ticket-management/company-list.vue"
          ),
        meta: {
          title: "公司管理",
          roles: ["ticket_management_company"],
          from: "company-list",
        },
      },
      {
        path: "company-add",
        name: "company-add",
        component: () =>
          import(
            /* webpackChunkName: "company-management" */ "../views/ticket-management/company-add.vue"
          ),
        meta: {
          title: "新增公司管理",
          roles: ["ticket_management_company"],
          from: "company-list",
          hidden: true,
        },
      },
      {
        path: "company-detail",
        name: "company-detail",
        component: () =>
          import(
            /* webpackChunkName: "company-management" */ "../views/ticket-management/company-detail.vue"
          ),
        meta: {
          title: "公司管理详情",
          roles: ["ticket_management_company"],
          from: "company-list",
          hidden: true,
        },
      },
      {
        path: "special-ticket-list",
        name: "special-ticket-list",
        component: () =>
          import(
            /* webpackChunkName: "special-management" */ "../views/ticket-management/special-ticket-list.vue"
          ),
        meta: {
          title: "特种票管理",
          roles: ["ticket_management_special_ticket"],
          from: "special-ticket-list",
        },
      },
      {
        path: "special-ticket-add",
        name: "special-ticket-add",
        component: () =>
          import(
            /* webpackChunkName: "special-management" */ "../views/ticket-management/special-ticket-add.vue"
          ),
        meta: {
          title: "新增特殊票",
          roles: ["ticket_management_special_ticket"],
          from: "special-ticket-list",
          hidden: true,
        },
      },

      {
        path: "inner-message-list",
        name: "inner-message-list",
        component: () =>
          import(
            /* webpackChunkName: "preview-management" */ "../views/ticket-management/inner-message-list.vue"
          ),
        meta: {
          title: "站内通知管理",
          roles: ["ticket_management_inner_message"],
          from: "inner-message-list",
        },
      },
      {
        path: "inner-message-add",
        name: "inner-message-add",
        component: () =>
          import(
            /* webpackChunkName: "preview-management" */ "../views/ticket-management/inner-message-add.vue"
          ),
        meta: {
          title: "站内信编辑",
          roles: ["ticket_management_inner_message"],
          from: "inner-message-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-ticket-list",
        name: "handwrite-ticket-list",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-ticket-list.vue"
          ),
        meta: {
          title: "手写票",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
        },
      },
      {
        path: "handwrite-apply-detail",
        name: "handwrite-apply-detail",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-apply-detail.vue"
          ),
        meta: {
          title: "手写票申请详情",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-ticket-detail",
        name: "handwrite-ticket-detail",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-ticket-detail.vue"
          ),
        meta: {
          title: "手写票车票详情",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-information-detail",
        name: "handwrite-information-detail",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-information-detail.vue"
          ),
        meta: {
          title: "手写票资讯详情",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-information-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-ticket-print",
        name: "handwrite-ticket-print",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-ticket-print.vue"
          ),
        meta: {
          title: "打印手写票",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-print-list",
        name: "handwrite-print-list",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-print-list.vue"
          ),
        meta: {
          title: "手写票打印记录",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
          hidden: true,
        },
      },
      {
        path: "handwrite-ticket-operate",
        name: "handwrite-ticket-operate",
        component: () =>
          import(
            /* webpackChunkName: "handwrite-management" */ "../views/ticket-management/handwrite-ticket-operate.vue"
          ),
        meta: {
          title: "转移",
          roles: ["ticket_management_handwrite_ticket"],
          from: "handwrite-ticket-list",
          hidden: true,
        },
      },
      {
        path: "site-restrictions-list",
        name: "site-restrictions-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/site-restrictions-list/index.vue"
          ),
        meta: {
          title: "站点限制可用",
          roles: ["ticket_management_site_restrictions_list"],
          from: "site-restrictions-list",
          hidden: false,
        },
      },
      {
        path: "site-restrictions-details",
        name: "site-restrictions-details",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/site-restrictions-details/index.vue"
          ),
        meta: {
          title: "站点限制可用详情",
          roles: ["ticket_management_site_restrictions_list"],
          from: "site-restrictions-list",
          hidden: true,
        },
      },
      {
        path: "transfer-rule-list",
        name: "transfer-rule-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/transfer-rule-list/index.vue"
          ),
        meta: {
          title: "指定接驳规则",
          roles: ["ticket_management_transfer_rule_list"],
          from: "transfer-rule-list",
          hidden: false,
        },
      },
      {
        path: "transfer-rule-details",
        name: "transfer-rule-details",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/transfer-rule-details/index.vue"
          ),
        meta: {
          title: "指定接驳规则详情",
          roles: ["ticket_management_transfer_rule_list"],
          from: "transfer-rule-list",
          hidden: true,
        },
      },
      {
        path: "restricted-ticket-list",
        name: "restricted-ticket-list",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/restricted-ticket-list/index.vue"
          ),
        meta: {
          title: "限制车票使用",
          roles: ["ticket_management_restricted_ticket_list"],
          from: "restricted-ticket-list",
          hidden: false,
        },
      },
      {
        path: "restricted-ticket-details",
        name: "restricted-ticket-details",
        component: () =>
          import(
            /* webpackChunkName: "ticket-management" */ "../views/ticket-management/restricted-ticket-details/index.vue"
          ),
        meta: {
          title: "限制车票使用详情",
          roles: ["ticket_management_restricted_ticket_list"],
          from: "restricted-ticket-list",
          hidden: true,
        },
      },
    ],
  },

  {
    path: "/price-management",
    name: "/price-management",
    component: Layout,
    meta: {
      title: "票价管理",
      icon: "price",
      roles: ["price_management"],
    },
    children: [
      {
        path: "standard-list",
        name: "standard-list",
        component: () =>
          import(
            /* webpackChunkName: "standard-management" */ "../views/price-management/standard-list.vue"
          ),
        meta: {
          title: "标准价",
          roles: ["price_management_standard"],
          from: "standard-list",
        },
      },
      {
        path: "standard-add",
        name: "standard-add",
        component: () =>
          import(
            /* webpackChunkName: "standard-management" */ "../views/price-management/standard-add.vue"
          ),
        meta: {
          title: "新增标准价",
          roles: ["price_management_standard"],
          from: "standard-list",
          hidden: true,
        },
      },
      {
        path: "standard-detail",
        name: "standard-detail",
        component: () =>
          import(
            /* webpackChunkName: "standard-management" */ "../views/price-management/standard-detail.vue"
          ),
        meta: {
          title: "标准价详情",
          roles: ["price_management_standard"],
          from: "standard-list",
          hidden: true,
        },
      },
      {
        path: "marketing-price-list",
        name: "marketing-price-list",
        component: () =>
          import(
            /* webpackChunkName: "marketing-price-management" */ "../views/price-management/marketing-price-list.vue"
          ),
        meta: {
          title: "营销价",
          roles: ["price_management_marketing"],
          from: "marketing-price-list",
        },
      },
      {
        path: "marketing-price-add",
        name: "marketing-price-add",
        component: () =>
          import(
            /* webpackChunkName: "marketing-price-management" */ "../views/price-management/marketing-price-add.vue"
          ),
        meta: {
          title: "新增营销价",
          roles: ["price_management_marketing"],
          from: "marketing-price-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/tour-product",
    name: "/tour-product",
    component: Layout,
    meta: {
      title: "旅游产品",
      icon: "camera",
      roles: ["tour-product"],
    },
    children: [
      {
        path: "supplier-list",
        name: "supplier-list",
        component: () =>
          import(
            /* webpackChunkName: "supplier-list" */ "../views/tour-product/supplier-list.vue"
          ),
        meta: {
          title: "供应商管理",
          roles: ["settlement_management_supplier"],
          from: "supplier-list",
        },
      },

      {
        path: "supplier-add",
        name: "supplier-add",
        component: () =>
          import(
            /* webpackChunkName: "supplier-list" */ "../views/tour-product/supplier-add.vue"
          ),
        meta: {
          title: "供应商新增",
          roles: ["settlement_management_supplier"],
          from: "supplier-list",
          hidden: true,
        },
      },
      {
        path: "supplier-detail",
        name: "supplier-detail",
        component: () =>
          import(
            /* webpackChunkName: "supplier-list" */ "../views/tour-product/supplier-detail.vue"
          ),
        meta: {
          title: "供应商详情",
          roles: ["settlement_management_supplier"],
          from: "supplier-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-self-list",
        name: "tour-product-self-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-self-list.vue"
          ),
        meta: {
          title: "自有产品管理",
          roles: ["tour-product-self-list"],
          from: "tour-product-self-list",
        },
      },
      {
        path: "tour-product-self-detail",
        name: "tour-product-self-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-self-detail.vue"
          ),
        meta: {
          title: "详情",
          roles: ["tour-product-self-list"],
          from: "tour-product-self-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-self-add",
        name: "tour-product-self-add",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-self-add.vue"
          ),
        meta: {
          title: "创建自有产品",
          roles: ["tour-product-self-list"],
          from: "tour-product-self-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-price-list",
        name: "tour-product-price-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-price-list.vue"
          ),
        meta: {
          title: "自有产品价格",
          roles: ["tour-product-price-list"],
          from: "tour-product-price-list",
        },
      },
      {
        path: "tour-product-price-detail",
        name: "tour-product-price-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-price-detail.vue"
          ),
        meta: {
          title: "价格政策详情",
          roles: ["tour-product-price-list"],
          from: "tour-product-price-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-price-add",
        name: "tour-product-price-add",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-price-add.vue"
          ),
        meta: {
          title: "创建价格政策",
          roles: ["tour-product-price-list"],
          from: "tour-product-price-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-self-sale",
        name: "tour-product-self-sale",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-self-sale.vue"
          ),
        meta: {
          title: "自有产品销售",
          roles: ["tour-product-self-sale"],
          from: "tour-product-self-sale",
        },
      },
      {
        path: "tour-product-order-list",
        name: "tour-product-order-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-order-list.vue"
          ),
        meta: {
          title: "自有产品订单",
          roles: ["tour-product-order-list"],
          from: "tour-product-order-list",
        },
      },
      {
        path: "tour-product-order-detail",
        name: "tour-product-order-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-order-detail.vue"
          ),
        meta: {
          title: "自有产品订单详情",
          roles: ["tour-product-order"],
          from: "tour-product-order",
        },
      },
      {
        path: "tour-product-entity-list",
        name: "tour-product-entity-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-entity-list.vue"
          ),
        meta: {
          title: "自有产品库存",
          roles: ["tour-product-entity-list"],
          from: "tour-product-entity-list",
        },
      },
      {
        path: "tour-product-entity-distribution",
        name: "tour-product-entity-distribution",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-entity-distribution.vue"
          ),
        meta: {
          title: "库存分配",
          roles: ["tour-product-entity-list"],
          from: "tour-product-entity-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-entity-add",
        name: "tour-product-entity-add",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-entity-add.vue"
          ),
        meta: {
          title: "库存新增",
          roles: ["tour-product-entity-list"],
          from: "tour-product-entity-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-hotel",
        name: "tour-product-hotel",
        meta: {
          title: "酒店产品",
          roles: ["tour-product-hotel"],
          from: "tour-product-hotel",
        },
        children: [
          {
            path: "tour-product-hotel-list",
            name: "tour-product-hotel-list",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-list.vue"
              ),
            meta: {
              title: "酒店管理",
              roles: ["tour-product-hotel-list"],
              from: "tour-product-hotel-list",
            },
          },
          {
            path: "tour-product-hotel-add",
            name: "tour-product-hotel-add",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-add.vue"
              ),
            meta: {
              title: "酒店新增",
              roles: ["tour-product-hotel-list"],
              from: "tour-product-hotel-list",
              hidden: true,
            },
          },
          {
            path: "tour-product-hotel-detail",
            name: "tour-product-hotel-detail",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-detail.vue"
              ),
            meta: {
              title: "酒店产品详情",
              roles: ["tour-product-hotel-list"],
              from: "tour-product-hotel-list",
              hidden: true,
            },
          },
          {
            path: "tour-product-hotel-price-list",
            name: "tour-product-hotel-price-list",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-price-list.vue"
              ),
            meta: {
              title: "酒店产品管理",
              roles: ["tour-product-hotel-price-list"],
              from: "tour-product-hotel-price-list",
            },
          },
          {
            path: "tour-product-hotel-price-add",
            name: "tour-product-hotel-price-add",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-price-add.vue"
              ),
            meta: {
              title: "酒店产品价格新增",
              roles: ["tour-product-hotel-price-list"],
              from: "tour-product-hotel-price-list",
              hidden: true,
            },
          },
          {
            path: "tour-product-hotel-price-detail",
            name: "tour-product-hotel-price-detail",
            component: () =>
              import(
                /* webpackChunkName: "tour-product-hotel" */ "../views/tour-product/tour-product-hotel/tour-product-hotel-price-detail.vue"
              ),
            meta: {
              title: "酒店产品价格详情",
              roles: ["tour-product-hotel-price-list"],
              from: "tour-product-hotel-price-list",
              hidden: true,
            },
          },
        ],
      },
      {
        path: "API-product-storage-list",
        name: "API-product-storage-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-storage-list.vue"
          ),
        meta: {
          title: "API产品入库",
          roles: ["API-product-storage-list"],
          from: "API-product-storage-list",
        },
      },
      {
        path: "API-product-storage-detail",
        name: "API-product-storage-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-storage-detail.vue"
          ),
        meta: {
          title: "API产品入库详情",
          roles: ["API-product-storage-list"],
          from: "API-product-storage-list",
          hidden: true,
        },
      },
      {
        path: "API-product-storage-edit",
        name: "API-product-storage-edit",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-storage-edit.vue"
          ),
        meta: {
          title: "API产品入库修改",
          roles: ["API-product-storage-list"],
          from: "API-product-storage-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-pack-list",
        name: "tour-product-pack-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-pack-list.vue"
          ),
        meta: {
          title: "产品打包管理",
          roles: ["tour-product-pack-list"],
          from: "tour-product-pack-list",
        },
      },
      {
        path: "tour-product-pack-add",
        name: "tour-product-pack-add",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-pack-add.vue"
          ),
        meta: {
          title: "产品打包新增",
          roles: ["tour-product-pack-list"],
          from: "tour-product-pack-list",
          hidden: true,
        },
      },
      {
        path: "tour-product-pack-detail",
        name: "tour-product-pack-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/tour-product-pack-detail.vue"
          ),
        meta: {
          title: "产品打包详情",
          roles: ["tour-product-pack-list"],
          from: "tour-product-pack-list",
          hidden: true,
        },
      },
      {
        path: "API-product-pack-sale",
        name: "API-product-pack-sale",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-pack-sale.vue"
          ),
        meta: {
          title: "旅游产品销售",
          roles: ["API-product-pack-sale"],
          from: "API-product-pack-sale",
        },
      },
      {
        path: "API-product-order-list",
        name: "API-product-order-list",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-order-list.vue"
          ),
        meta: {
          title: "旅游产品订单",
          roles: ["API-product-order-list"],
          from: "API-product-order-list",
        },
      },
      {
        path: "API-product-order-detail",
        name: "API-product-order-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/API-product-order-detail.vue"
          ),
        meta: {
          title: "旅游产品订单详情",
          roles: ["API-product-order-list"],
          from: "API-product-order-list",
          hidden: true,
        },
      },
      {
        path: "cycle-inventory-management",
        name: "cycle-inventory-management",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/cycle-inventory-management.vue"
          ),
        meta: {
          title: "周期库存管理",
          roles: ["cycle-inventory-management"],
          from: "cycle-inventory-management",
        },
      },
      {
        path: "cycle-inventory-add",
        name: "cycle-inventory-add",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/cycle-inventory-add.vue"
          ),
        meta: {
          title: "新增周期库存管理",
          roles: ["cycle-inventory-management"],
          from: "cycle-inventory-management",
          hidden: true,
        },
      },
      {
        path: "cycle-inventory-detail",
        name: "cycle-inventory-detail",
        component: () =>
          import(
            /* webpackChunkName: "tour-product" */ "../views/tour-product/cycle-inventory-detail.vue"
          ),
        meta: {
          title: "周期库存管理详情",
          roles: ["cycle-inventory-management"],
          from: "cycle-inventory-management",
          hidden: true,
        },
      },
      {
        path: "data-analyse",
        name: "data-analyse",
        component: () =>
          import(
            /* webpackChunkName: "data-analyse" */ "../views/tour-product/data-analyse.vue"
          ),
        meta: {
          title: "旅游产品数据",
          roles: ["tour-product-sales-datas"],
          from: "data-analyse",
        },
      },
    ],
  },
  {
    path: "/settlement-management",
    name: "/settlement-management",
    component: Layout,
    meta: {
      title: "结算管理",
      icon: "notebook",
      roles: ["settlement_management"],
    },
    children: [
      {
        path: "yushen-settlement",
        name: "yushen-settlement",
        component: () =>
          import(
            /* webpackChunkName: "yushen-settlement" */ "../views/settlement-management/yushen-settlement.vue"
          ),
        meta: {
          title: "门市预审单",
          roles: ["settlement_management_examine"],
          from: "yushen-settlement",
        },
      },
      {
        path: "add-yushen",
        name: "add-yushen",
        component: () =>
          import(
            /* webpackChunkName: "yushen-settlement" */ "../views/settlement-management/add-yushen.vue"
          ),
        meta: {
          title: "今日营收",
          roles: ["settlement_management_examine"],
          from: "yushen-settlement",
          hidden: true,
        },
      },
      {
        path: "yushen-detail",
        name: "yushen-detail",
        component: () =>
          import(
            /* webpackChunkName: "yushen-settlement" */ "../views/settlement-management/yushen-detail.vue"
          ),
        meta: {
          title: "预审单详情",
          roles: ["settlement_management_examine"],
          from: "yushen-settlement",
          hidden: true,
        },
      },
      {
        path: "deposit-settlement",
        name: "deposit-settlement",
        component: () =>
          import(
            /* webpackChunkName: "deposit-settlement" */ "../views/settlement-management/deposit-settlement.vue"
          ),
        meta: {
          title: "门市存款单",
          roles: ["settlement_management_deposit"],
          from: "deposit-settlement",
        },
      },
      {
        path: "deposit-detail",
        name: "deposit-detail",
        component: () =>
          import(
            /* webpackChunkName: "deposit-settlement" */ "../views/settlement-management/deposit-detail.vue"
          ),
        meta: {
          title: "存款单详情",
          roles: ["settlement_management_deposit"],
          from: "deposit-settlement",
          hidden: true,
        },
      },
      {
        path: "edit-deposit-settlement",
        name: "edit-deposit-settlement",
        component: () =>
          import(
            /* webpackChunkName: "deposit-settlement" */ "../views/settlement-management/edit-deposit-settlement.vue"
          ),
        meta: {
          title: "上传存款信息",
          roles: ["settlement_management_deposit"],
          from: "deposit-settlement",
          hidden: true,
        },
      },
      {
        path: "edit-deposit-settlement-finance",
        name: "edit-deposit-settlement-finance",
        component: () =>
          import(
            /* webpackChunkName: "deposit-settlement" */ "../views/settlement-management/edit-deposit-settlement-finance.vue"
          ),
        meta: {
          title: "上传财务调整单",
          roles: ["settlement_management_deposit"],
          from: "deposit-settlement",
          hidden: true,
        },
      },

      {
        path: "transaction-method",
        name: "transaction-method",
        component: () =>
          import(
            /* webpackChunkName: "transaction-method" */ "../views/settlement-management/transaction-method.vue"
          ),
        meta: {
          title: "门市交易方式",
          roles: ["settlement_management_transaction_method"],
          from: "transaction-method",
        },
      },
      {
        path: "transaction-method-add",
        name: "transaction-method-add",
        component: () =>
          import(
            /* webpackChunkName: "transaction-method" */ "../views/settlement-management/transaction-method-add.vue"
          ),
        meta: {
          title: "新增交易方式",
          roles: ["settlement_management_transaction_method"],
          from: "transaction-method",
          hidden: true,
        },
      },
      {
        path: "transaction-method-detail",
        name: "transaction-method-detail",
        component: () =>
          import(
            /* webpackChunkName: "transaction-method" */ "../views/settlement-management/transaction-method-detail.vue"
          ),
        meta: {
          title: "交易方式详情",
          roles: ["settlement_management_transaction_method"],
          from: "transaction-method",
          hidden: true,
        },
      },
      {
        path: "payment-method",
        name: "payment-method",
        component: () =>
          import(
            /* webpackChunkName: "payment-method" */ "../views/settlement-management/payment-method.vue"
          ),
        meta: {
          title: "收款方式",
          roles: ["settlement_management_payment_method"], // 这个是最新的需要配置
          from: "payment-method",
        },
      },
      {
        path: "payment-method-add",
        name: "payment-method-add",
        component: () =>
          import(
            /* webpackChunkName: "payment-method" */ "../views/settlement-management/payment-method-add.vue"
          ),
        meta: {
          title: "收款方式新增",
          roles: ["settlement_management_payment_method"], // 这个是最新的需要配置
          from: "payment-method",
          hidden: true,
        },
      },
      {
        path: "payment-method-detail",
        name: "payment-method-detail",
        component: () =>
          import(
            /* webpackChunkName: "payment-method" */ "../views/settlement-management/payment-method-detail.vue"
          ),
        meta: {
          title: "收款方式详情",
          roles: ["settlement_management_payment_method"], // 这个是最新的需要配置
          from: "payment-method",
          hidden: true,
        },
      },
      {
        path: "agency-yushen-settlement-list",
        name: "agency-yushen-settlement-list",
        component: () =>
          import(
            /* webpackChunkName: "agency-yushen-settlement-list" */ "../views/settlement-management/agency-yushen-settlement-list.vue"
          ),
        meta: {
          title: "代理预审单",
          roles: ["settlement_management_agency"],
          from: "agency-yushen-settlement-list",
        },
      },
      {
        path: "agency-yushen-settlement-detail",
        name: "agency-yushen-settlement-detail",
        component: () =>
          import(
            /* webpackChunkName: "agency-yushen-settlement-detail" */ "../views/settlement-management/agency-yushen-settlement-detail.vue"
          ),
        meta: {
          title: "代理预审单详情",
          roles: ["settlement_management_agency"],
          from: "agency-yushen-settlement-list",
          hidden: true,
        },
      },
      {
        path: "agency-deposit-list",
        name: "agency-deposit-list",
        component: () =>
          import(
            /* webpackChunkName: "agency-deposit-list" */ "../views/settlement-management/agency-deposit-list.vue"
          ),
        meta: {
          title: "代理存款单",
          roles: ["settlement_management_agency_deposit"],
          from: "agency-deposit-list",
        },
      },
      {
        path: "agency-deposit-detail",
        name: "agency-deposit-detail",
        component: () =>
          import(
            /* webpackChunkName: "agency-deposit-detail" */ "../views/settlement-management/agency-deposit-detail.vue"
          ),
        meta: {
          title: "代理存款单详情",
          roles: ["settlement_management_agency_deposit"],
          from: "agency-deposit-list",
          hidden: true,
        },
      },
      {
        path: "agency-deposit-add",
        name: "agency-deposit-add",
        component: () =>
          import(
            /* webpackChunkName: "agency-deposit-add" */ "../views/settlement-management/agency-deposit-add.vue"
          ),
        meta: {
          title: "代理存款单新增",
          roles: ["settlement_management_agency_deposit"],
          from: "agency-deposit-list",
          hidden: true,
        },
      },

      {
        path: "exchange-rate",
        name: "exchange-rate",
        component: () =>
          import(
            /* webpackChunkName: "exchange-rate" */ "../views/settlement-management/exchange-rate.vue"
          ),
        meta: {
          title: "汇率管理",
          roles: ["settlement_management_exchange_rate"],
          from: "exchange-rate",
        },
      },
      {
        path: "exchange-rate-add",
        name: "exchange-rate-add",
        component: () =>
          import(
            /* webpackChunkName: "exchange-rate" */ "../views/settlement-management/exchange-rate-add.vue"
          ),
        meta: {
          title: "新增汇率",
          roles: ["settlement_management_exchange_rate"],
          from: "exchange-rate",
          hidden: true,
        },
      },
      {
        path: "exchange-rate-detail",
        name: "exchange-rate-detail",
        component: () =>
          import(
            /* webpackChunkName: "exchange-rate" */ "../views/settlement-management/exchange-rate-detail.vue"
          ),
        meta: {
          title: "汇率详情",
          roles: ["settlement_management_exchange_rate"],
          from: "exchange-rate",
          hidden: true,
        },
      },

      {
        path: "collecting-company-list",
        name: "collecting-company-list",
        component: () =>
          import(
            /* webpackChunkName: "collecting-company-list" */ "../views/settlement-management/collecting-company-list.vue"
          ),
        meta: {
          title: "收款公司管理",
          roles: ["settlement_management_collecting_company"],
          from: "collecting-company-list",
        },
      },
      {
        path: "collecting-company-add",
        name: "collecting-company-add",
        component: () =>
          import(
            /* webpackChunkName: "collecting-company-list" */ "../views/settlement-management/collecting-company-add.vue"
          ),
        meta: {
          title: "收款公司新增",
          roles: ["settlement_management_collecting_company"],
          from: "collecting-company-list",
          hidden: true,
        },
      },
      {
        path: "collecting-company-detail",
        name: "collecting-company-detail",
        component: () =>
          import(
            /* webpackChunkName: "collecting-company-list" */ "../views/settlement-management/collecting-company-detail.vue"
          ),
        meta: {
          title: "收款公司详情",
          roles: ["settlement_management_collecting_company"],
          from: "collecting-company-list",
          hidden: true,
        },
      },

      {
        path: "monthly-settlement-list",
        name: "monthly-settlement-list",
        component: () =>
          import(
            /* webpackChunkName: "monthly-settlement-list" */ "../views/settlement-management/monthly-settlement-list.vue"
          ),
        meta: {
          title: "月结",
          roles: ["settlement_management_monthly_settlement"],
          from: "monthly-settlement-list",
        },
      },
      {
        path: "monthly-settlement-add",
        name: "monthly-settlement-add",
        component: () =>
          import(
            /* webpackChunkName: "monthly-settlement-list" */ "../views/settlement-management/monthly-settlement-add.vue"
          ),
        meta: {
          title: "新增月结",
          roles: ["settlement_management_monthly_settlement"],
          from: "monthly-settlement-list",
          hidden: true,
        },
      },
      {
        path: "transaction-history",
        name: "transaction-history",
        component: () =>
          import(
            /* webpackChunkName: "transaction-history" */ "../views/settlement-management/transaction-history.vue"
          ),
        meta: {
          title: "交易记录查询",
          roles: ["transaction-history"],
          from: "transaction-history",
        },
      },
      {
        path: "pos-list",
        name: "pos-list",
        component: () =>
          import(
            /* webpackChunkName: "pos-management" */ "../views/settlement-management/pos-list.vue"
          ),
        meta: {
          title: "POS机列表",
          roles: ["pos_list"],
          from: "pos-list",
        },
      },
      {
        path: "pos-detail",
        name: "pos-detail",
        component: () =>
          import(
            /* webpackChunkName: "pos-management" */ "../views/settlement-management/pos-detail.vue"
          ),
        meta: {
          title: "POS机详情",
          roles: ["pos_list"],
          from: "pos-list",
          hidden: true,
        },
      },
      {
        path: "pos-add",
        name: "pos-add",
        component: () =>
          import(
            /* webpackChunkName: "pos-management" */ "../views/settlement-management/pos-add.vue"
          ),
        meta: {
          title: "新增POS机",
          roles: ["pos_list"],
          from: "pos-list",
          hidden: true,
        },
      },
      {
        path: "pos-operate-log",
        name: "pos-operate-log",
        component: () =>
          import(
            /* webpackChunkName: "pos-operate-log" */ "../views/settlement-management/pos-operate-log.vue"
          ),
        meta: {
          title: "POS操作日志",
          roles: ["operate_log_list"],
          from: "pos-operate-log",
        },
      },
    ],
  },
  {
    path: "/statistics-management",
    name: "/statistics-management",
    component: Layout,
    meta: {
      title: "经营统计管理",
      icon: "analyze",
      roles: ["statistics-management"],
    },
    children: [
      {
        path: "statistical-route-list",
        name: "statistical-route-list",
        component: () =>
          import(
            /* webpackChunkName: "statistical-route-list" */ "../views/statistics-management/statistical-route-list.vue"
          ),
        meta: {
          title: "统计路线",
          roles: ["statistics_management_route_list"],
          from: "statistical-route-list",
        },
      },
      {
        path: "statistical-route-add",
        name: "statistical-route-add",
        component: () =>
          import(
            /* webpackChunkName: "statistical-route-list" */ "../views/statistics-management/statistical-route-add.vue"
          ),
        meta: {
          title: "统计路线新增",
          roles: ["statistics_management_route_list"],
          from: "statistical-route-list",
          hidden: true,
        },
      },
      {
        path: "statistical-route-detail",
        name: "statistical-route-detail",
        component: () =>
          import(
            /* webpackChunkName: "statistical-route-list" */ "../views/statistics-management/statistical-route-detail.vue"
          ),
        meta: {
          title: "统计路线详情",
          roles: ["statistics_management_route_list"],
          from: "statistical-route-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/organize-management",
    name: "/organize-management",
    component: Layout,
    meta: {
      title: "组织架构",
      icon: "user",
      roles: ["organize_management"],
    },
    children: [
      {
        path: "unit-list",
        name: "unit-list",
        component: () =>
          import(
            /* webpackChunkName: "unit-management" */ "../views/organize-management/unit-list.vue"
          ),
        meta: {
          title: "管理机构",
          roles: ["organize_management_unit"],
          from: "unit-list",
        },
      },
      {
        path: "unit-add",
        name: "unit-add",
        component: () =>
          import(
            /* webpackChunkName: "unit-management" */ "../views/organize-management/unit-add.vue"
          ),
        meta: {
          title: "管理机构新增",
          roles: ["organize_management_unit"],
          from: "unit-list",
          hidden: true,
        },
      },
      {
        path: "unit-detail",
        name: "unit-detail",
        component: () =>
          import(
            /* webpackChunkName: "unit-management" */ "../views/organize-management/unit-detail.vue"
          ),
        meta: {
          title: "管理机构详情",
          roles: ["organize_management_unit"],
          from: "unit-list",
          hidden: true,
        },
      },
      {
        path: "store-list",
        name: "store-list",
        component: () =>
          import(
            /* webpackChunkName: "store-management" */ "../views/organize-management/store-list.vue"
          ),
        meta: {
          title: "门市",
          roles: ["organize_management_store"],
          from: "store-list",
        },
      },
      {
        path: "store-add",
        name: "store-add",
        component: () =>
          import(
            /* webpackChunkName: "store-management" */ "../views/organize-management/store-add.vue"
          ),
        meta: {
          title: "新增门市",
          roles: ["organize_management_store"],
          from: "store-list",
          hidden: true,
        },
      },
      {
        path: "store-detail",
        name: "store-detail",
        component: () =>
          import(
            /* webpackChunkName: "store-management" */ "../views/organize-management/store-detail.vue"
          ),
        meta: {
          title: "门市详情",
          roles: ["organize_management_store"],
          from: "store-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/report-management",
    name: "/report-management",
    component: Layout,
    meta: {
      title: "报表管理",
      icon: "reading",
      roles: ["report_management"],
    },
    children: [
      {
        path: "download-list",
        name: "download-list",
        component: () =>
          import(
            /* webpackChunkName: "report-management" */ "../views/report-management/download-list.vue"
          ),
        meta: {
          title: "预约下载",
          roles: ["report_management"],
          from: "download-list",
        },
      },
      {
        path: "business-report",
        meta: {
          title: "业务报表",
          roles: ["report_management_business"],
          from: "business-report",
        },
        children: [
          {
            path: "business-a",
            name: "business-a",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-a.vue"
              ),
            meta: {
              title: "线路班次统计",
              roles: ["report_management_business_a"],
              from: "business-a",
            },
          },
          {
            path: "business-b",
            name: "business-b",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-b.vue"
              ),
            meta: {
              title: "南行关口人数",
              roles: ["report_management_business_b"],
              from: "business-b",
            },
          },
          {
            path: "business-c",
            name: "business-c",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-c.vue"
              ),
            meta: {
              title: "A区发车时间",
              roles: ["report_management_business_c"],
              from: "business-c",
            },
          },
          {
            path: "business-d",
            name: "business-d",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-d.vue"
              ),
            meta: {
              title: "B区发车时间",
              roles: ["report_management_business_d"],
              from: "business-d",
            },
          },
          {
            path: "business-e",
            name: "business-e",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-e.vue"
              ),
            meta: {
              title: "站点发车时间",
              roles: ["report_management_business_e"],
              from: "business-e",
            },
          },
          {
            path: "business-f",
            name: "business-f",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-f.vue"
              ),
            meta: {
              title: "北行关口人数",
              roles: ["report_management_business_f"],
              from: "business-f",
            },
          },
          {
            path: "business-g",
            name: "business-g",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-g.vue"
              ),
            meta: {
              title: "班车业绩月报",
              roles: ["report_management_business_g"],
              from: "business-g",
            },
          },
          {
            path: "business-h",
            name: "business-h",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-h.vue"
              ),
            meta: {
              title: "每日取留人数",
              roles: ["report_management_business_h"],
              from: "business-h",
            },
          },
          {
            path: "business-i",
            name: "business-i",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-i.vue"
              ),
            meta: {
              title: "万能报表销售",
              roles: ["report_management_business_i"],
              from: "business-i",
            },
          },
          {
            path: "business-j",
            name: "business-j",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-j.vue"
              ),
            meta: {
              title: "万能报表取位",
              roles: ["report_management_business_j"],
              from: "business-j",
            },
          },
          {
            path: "business-k",
            name: "business-k",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-k.vue"
              ),
            meta: {
              title: "乘坐人数表",
              roles: ["report_management_business_k"],
              from: "business-k",
            },
          },
          {
            path: "business-l",
            name: "business-l",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-l.vue"
              ),
            meta: {
              title: "上下站人数表",
              roles: ["report_management_business_l"],
              from: "business-l",
            },
          },
          {
            path: "business-m",
            name: "business-m",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-m.vue"
              ),
            meta: {
              title: "假期对比表",
              roles: ["report_management_business_m"],
              from: "business-m",
            },
          },
          {
            path: "business-n",
            name: "business-n",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-n.vue"
              ),
            meta: {
              title: "荃湾人数统计",
              roles: ["report_management/business_n"],
              from: "business-n",
            },
          },
          {
            path: "business-o",
            name: "business-o",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-o.vue"
              ),
            meta: {
              title: "香港机场明细",
              roles: ["report_management_business_o"],
              from: "business-o",
            },
          },
          {
            path: "business-p",
            name: "business-p",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-p.vue"
              ),
            meta: {
              title: "逾期车票表",
              roles: ["report_management_business_p"],
              from: "business-p",
            },
          },
          {
            path: "business-r",
            name: "business-r",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-r.vue"
              ),
            meta: {
              title: "扫描审核表",
              roles: ["report_management_business_r"],
              from: "business-r",
            },
          },
          {
            path: "business-q",
            name: "business-q",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-q.vue"
              ),
            meta: {
              title: "门市收入表",
              roles: ["report_management/business-q"],
              from: "business-q",
            },
          },
          {
            path: "business-s",
            name: "business-s",
            component: () =>
              import(
                /* webpackChunkName: "business-report" */ "../views/report-management/business-report/business-s.vue"
              ),
            meta: {
              title: "乘坐收入表",
              roles: ["report_management/business-s"],
              from: "business-s",
            },
          },
          {
            path: "business-t",
            name: "business-t",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-t.vue"
              ),
            meta: {
              title: "门市分析表",
              roles: ["report_management_business_t"],
              from: "business-t",
            },
          },
          {
            path: "business-u",
            name: "business-u",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-u.vue"
              ),
            meta: {
              title: "包车单人数表",
              roles: ["report_management_business-u"],
              from: "business-u",
            },
          },
          {
            path: "business-v",
            name: "business-v",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-v.vue"
              ),
            meta: {
              title: "粤港锁位表",
              roles: ["report_management_business-v"],
              from: "business-v",
            },
          },
          {
            path: "business-x",
            name: "business-x",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-x.vue"
              ),
            meta: {
              title: "数据库记录表",
              roles: ["report_management_business-x"],
              from: "business-x",
            },
          },
          {
            path: "business-w",
            name: "business-w",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-w.vue"
              ),
            meta: {
              title: "站点人数表",
              roles: ["report_management_business-w"],
              from: "business-w",
            },
          },
          {
            path: "business-y",
            name: "business-y",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-y.vue"
              ),
            meta: {
              title: "现金券使用表",
              roles: ["report_management_business_y"],
              from: "business-y",
            },
          },
          {
            path: "seat-hold-stats",
            name: "seat-hold-stats",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/seat-hold-stats.vue"
              ),
            meta: {
              title: "取位留位人数统计",
              roles: ["report_management_business_seat_hold_stats"],
              from: "seat-hold-stats",
            },
          },
          {
            path: "business-z",
            name: "business-z",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-z.vue"
              ),
            meta: {
              title: "关口人数表",
              roles: ["report_management_business_z"],
              from: "business-z",
            },
          },
          {
            path: "business-scan-correct",
            name: "business-scan-correct",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-scan-correct.vue"
              ),
            meta: {
              title: "扫错还原表",
              roles: ["report_management_business_scan_correct"],
              from: "business-scan-correct",
            },
          },
          {
            path: "business-common-to-open",
            name: "business-common-to-open",
            component: () =>
              import(
                /* webpackChunkName: "report-management" */ "../views/report-management/business-report/business-common-to-open.vue"
              ),
            meta: {
              title: "消位记录表",
              roles: ["report_management_business_common_to_open"],
              from: "business-common-to-open",
            },
          },
        ],
      },
      {
        path: "settlement-report",
        meta: {
          title: "结算报表",
          roles: ["report_management_settlement"],
          from: "settlement-report",
        },
        children: [
          {
            path: "settlement-a",
            name: "settlement-a",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-a.vue"
              ),
            meta: {
              title: "操作员售出",
              roles: ["report_management/settlement-a"],
              from: "settlement-a",
            },
          },
          {
            path: "settlement-b",
            name: "settlement-b",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-b.vue"
              ),
            meta: {
              title: "退票记录",
              roles: ["report_management/settlement-b"],
              from: "settlement-b",
            },
          },

          {
            path: "settlement-f",
            name: "settlement-f",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-f.vue"
              ),
            meta: {
              title: "更改行程表",
              roles: ["report_management_settlement_f"],
              from: "settlement-f",
            },
          },
          {
            path: "settlement-g",
            name: "settlement-g",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-g.vue"
              ),
            meta: {
              title: "包车票报表",
              roles: ["report_management_settlement_g"],
              from: "settlement-g",
            },
          },
          {
            path: "settlement-h",
            name: "settlement-h",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-h.vue"
              ),
            meta: {
              title: "代理营收报表",
              roles: ["report_management_settlement_h"],
              from: "settlement-h",
            },
          },
          {
            path: "settlement-i",
            name: "settlement-i",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-i.vue"
              ),
            meta: {
              title: "港澳快线表",
              roles: ["report_management_settlement_i_detail"],
              from: "settlement-i",
            },
          },
          {
            path: "settlement-j",
            name: "settlement-j",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-j.vue"
              ),
            meta: {
              title: "代理库存表",
              roles: ["report_management_settlement_j"],
              from: "settlement-j",
            },
          },
          {
            path: "settlement-k",
            name: "settlement-k",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-k.vue"
              ),
            meta: {
              title: "门市营收表",
              roles: ["report_management_settlement_k"],
              from: "settlement-k",
            },
          },
          {
            path: "settlement-o",
            name: "settlement-o",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-o.vue"
              ),
            meta: {
              title: "系统外已售表",
              roles: ["report_management_settlement_o"],
              from: "settlement-o",
            },
          },
          {
            path: "settlement-p",
            name: "settlement-p",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-p.vue"
              ),
            meta: {
              title: "已领车票表",
              roles: ["report_management_settlement_p"],
              from: "settlement-p",
            },
          },
          {
            path: "settlement-q",
            name: "settlement-q",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-q.vue"
              ),
            meta: {
              title: "票款汇总表",
              roles: ["report_management_settlement_q"],
              from: "settlement-p",
            },
          },
          {
            path: "settlement-t",
            name: "settlement-t",
            component: () =>
              import(
                /* webpackChunkName: "settlement-management" */ "../views/report-management/settlement-report/settlement-t.vue"
              ),
            meta: {
              title: "团体票报表",
              roles: ["report_management_settlement_t"],
              from: "settlement-t",
            },
          },
        ],
      },
      {
        path: "finance-report",
        meta: {
          title: "财务报表",
          roles: ["report_management_finance"],
          from: "finance-report",
        },
        children: [
          {
            path: "finance-a",
            name: "finance-a",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-a.vue"
              ),
            meta: {
              title: "平均票价分析表",
              roles: ["report_management_finance_a"],
              from: "finance-a",
            },
          },
          {
            path: "finance-b",
            name: "finance-b",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-b.vue"
              ),
            meta: {
              title: "账龄分析表",
              roles: ["report_management_finance_b"],
              from: "finance-b",
            },
          },
          {
            path: "finance-c",
            name: "finance-c",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-c.vue"
              ),
            meta: {
              title: "财务营收报表",
              roles: ["report_management_finance_c"],
              from: "finance-c",
            },
          },
          {
            path: "finance-d",
            name: "finance-d",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-d.vue"
              ),
            meta: {
              title: "递延收入",
              roles: ["report_management_finance_d"],
              from: "finance-d",
            },
          },
          {
            path: "finance-e",
            name: "finance-e",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-e.vue"
              ),
            meta: {
              title: "收款单",
              roles: ["report_management_finance_e"],
              from: "finance-e",
            },
          },
          {
            path: "finance-f",
            name: "finance-f",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-f.vue"
              ),
            meta: {
              title: "订单汇总表",
              roles: ["report_management_finance_f"],
              from: "finance-f",
            },
          },
          {
            path: "finance-g",
            name: "finance-g",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-g.vue"
              ),
            meta: {
              title: "预付款销售报表",
              roles: ["report_management_finance_g"],
              from: "finance-g",
            },
          },
          {
            path: "finance-h",
            name: "finance-h",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-h.vue"
              ),
            meta: {
              title: "预审单报表",
              roles: ["report_management_finance_h"],
              from: "finance-h",
            },
          },
          {
            path: "finance-i",
            name: "finance-i",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-i.vue"
              ),
            meta: {
              title: "逾期车票报表",
              roles: ["report_management_finance_i"],
              from: "finance-i",
            },
          },
          {
            path: "finance-j",
            name: "finance-j",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-j.vue"
              ),
            meta: {
              title: "退票记录报表",
              roles: ["report_management_finance_j"],
              from: "finance-j",
            },
          },
          {
            path: "finance-k",
            name: "finance-k",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-k.vue"
              ),
            meta: {
              title: "应收明细报表",
              roles: ["report_management_finance_k"],
              from: "finance-k",
            },
          },
          {
            path: "finance-l",
            name: "finance-l",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-l.vue"
              ),
            meta: {
              title: "门市营收汇总表",
              roles: ["report_management_finance_l"],
              from: "finance-l",
            },
          },
          {
            path: "finance-m",
            name: "finance-m",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-m.vue"
              ),
            meta: {
              title: "班次业绩月报表",
              roles: ["report_management_finance_m"],
              from: "finance-m",
            },
          },
          {
            path: "finance-n",
            name: "finance-n",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-n.vue"
              ),
            meta: {
              title: "已乘坐车票表",
              roles: ["report_management/finance-n"],
              from: "finance-n",
            },
          },
          {
            path: "finance-o",
            name: "finance-o",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-o.vue"
              ),
            meta: {
              title: "旅游产品报表",
              roles: ["report_management/finance-o"],
              from: "finance-o",
            },
          },
          {
            path: "finance-p",
            name: "finance-p",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-p.vue"
              ),
            meta: {
              title: "联营分成表",
              roles: ["report_management/finance-p"],
              from: "finance-p",
            },
          },
          {
            path: "finance-q",
            name: "finance-q",
            component: () =>
              import(
                /* webpackChunkName: "finance-management" */ "../views/report-management/finance-report/finance-q.vue"
              ),
            meta: {
              title: "国泰对账单",
              roles: ["report_management/finance-q"],
              from: "finance-q",
            },
          },
        ],
      },
      {
        path: "prepay-report",
        meta: {
          title: "预付款报表",
          roles: ["report_management_prepay"],
          from: "prepay-report",
        },
        children: [
          {
            path: "prepay-a",
            name: "prepay-a",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-a.vue"
              ),
            meta: {
              title: "充值记录表",
              roles: ["report_management_prepay_a"],
              from: "prepay-a",
            },
          },
          {
            path: "prepay-b",
            name: "prepay-b",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-b.vue"
              ),
            meta: {
              title: "预付款审核表",
              roles: ["report_management_prepay_b"],
              from: "prepay-b",
            },
          },
          {
            path: "prepay-c",
            name: "prepay-c",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-c.vue"
              ),
            meta: {
              title: "额度转移表",
              roles: ["report_management_prepay_c"],
              from: "prepay-c",
            },
          },
          {
            path: "prepay-d",
            name: "prepay-d",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-d.vue"
              ),
            meta: {
              title: "预付款剩余表",
              roles: ["report_management_prepay_d"],
              from: "prepay-d",
            },
          },
          {
            path: "prepay-e",
            name: "prepay-e",
            component: () =>
              import(
                /* webpackChunkName: "prepay-management" */ "../views/report-management/prepay-report/prepay-e.vue"
              ),
            meta: {
              title: "预付款剩余汇总",
              roles: ["report_management_prepay_e"],
              from: "prepay-e",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/marketing-management",
    name: "/marketing-management",
    component: Layout,
    meta: {
      title: "营销管理",
      icon: "wallet",
      roles: ["marketing_management"],
    },
    children: [
      {
        path: "coupon-list",
        name: "coupon-list",
        component: () =>
          import(
            /* webpackChunkName: "marketing-management" */ "../views/marketing-management/coupon-list.vue"
          ),
        meta: {
          title: "现金券",
          roles: ["marketing_management_coupon"],
          from: "coupon-list",
        },
      },
      {
        path: "coupon-add-rule",
        name: "coupon-add-rule",
        component: () =>
          import(
            /* webpackChunkName: "marketing-management" */ "../views/marketing-management/coupon-add-rule.vue"
          ),
        meta: {
          title: "新增现金券规则",
          roles: ["marketing_management_coupon"],
          from: "coupon-list",
          hidden: true,
        },
      },
      {
        path: "coupon-add-number",
        name: "coupon-add-number",
        component: () =>
          import(
            /* webpackChunkName: "marketing-management" */ "../views/marketing-management/coupon-add-number.vue"
          ),
        meta: {
          title: "新增现金券数量",
          roles: ["marketing_management_coupon"],
          from: "coupon-list",
          hidden: true,
        },
      },
      {
        path: "coupon-detail-number",
        name: "coupon-detail-number",
        component: () =>
          import(
            /* webpackChunkName: "marketing-management" */ "../views/marketing-management/coupon-detail-number.vue"
          ),
        meta: {
          title: "现金券规则详情",
          roles: ["marketing_management_coupon"],
          from: "coupon-list",
          hidden: true,
        },
      },
      {
        path: "coupon-print",
        name: "coupon-print",
        component: () =>
          import(
            /* webpackChunkName: "marketing-management" */ "../views/marketing-management/coupon-print.vue"
          ),
        meta: {
          title: "现金券打印详情页",
          roles: ["marketing_management_coupon"],
          from: "coupon-list",
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/system-tools",
    name: "/system-tools",
    component: Layout,
    meta: {
      title: "系统工具",
      icon: "account",
      roles: ["system_tools"],
    },
    children: [
      {
        path: "ticket-monitor",
        name: "ticket-monitor",
        component: () =>
          import(
            /* webpackChunkName: "system-tools" */ "../views/system-tools/ticket-monitor/index.vue"
          ),
        meta: {
          title: "验票监控",
          roles: ["system_tools_ticket_monitor"],
          from: "ticket-monitor",
        },
      },
      {
        path: "yg-notify-monitor",
        name: "yg-notify-monitor",
        component: () =>
          import(
            /* webpackChunkName: "system-tools" */ "../views/system-tools/yg-notify-monitor/index.vue"
          ),
        meta: {
          title: "粤港消息监控",
          roles: ["system_tools_yg_notify_monitor"],
          from: "yg-notify-monitor",
        },
      },
      {
        path: "yg-notify-monitor/detail",
        name: "yg-notify-monitor-detail",
        component: () =>
          import(
            /* webpackChunkName: "system-tools" */ "../views/system-tools/yg-notify-monitor/detail.vue"
          ),
        meta: {
          title: "通知日志详情",
          hidden: true,
        },
      },
    ],
  },
  // {
  //   path: "/lowcode",
  //   name: "/lowcode",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "business-b",
  //       name: "business-b",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "lowcode-management" */ "../views/lowcode/index.vue"
  //         ),
  //       meta: {
  //         title: "xxx报表",
  //         hidden: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/report-management/business-report/business-x",
  //   redirect: "/lowcode/business-b",
  // },
  {
    path: "/quick-search-ticket",
    name: "/quick-search-ticket",
    component: () =>
      import(
        /* webpackChunkName: "quick-search-ticket" */ "../views/order-tickets-management/quick-search-ticket.vue"
      ),
    meta: {
      title: "快速查票",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "nonPage",
    component: ErrorPage,
    meta: {
      title: "暂无页面",
    },
  },
];

const whiteList = ["/app-download", "/home/no-permission"];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeResolve((to: any, from) => {
  const { userStore } = usePiniaStore();
  const token = localStorage.getItem("token_value");

  // 跳转到登录页面或无权限页面前，保存之前的菜单操作记录
  if (to.path === "/login" || to.path === "/home/no-permission") {
    return;
  }

  if (to.query.token) {
    localStorage.setItem("token_value", to.query.token);
  } else {
    const { pathname, search } = window.location;
    // 首次访问时，为null。 主动清空登录、401清空登录为空
    if (token === null && !whiteList.includes(pathname)) {
      // 当前无登录态，直接跳转登录页面。
      sessionStorage.setItem("redirectUrl", pathname + search); // 记录当前路由URL
      router.replace(`/login`); // 跳转到登录页面
      return;
    }
  }

  // 权限检查：如果用户已登录，检查是否有访问当前路由的权限
  if (token && userStore.roles.length > 0 && to.meta?.roles?.length > 0) {
    // 检查当前路由是否有权限
    if (!userStore.roles.includes(to.meta?.roles[0])) {
      // 重定向到无权限页面
      router.replace("/home/no-permission");
      return;
    }
  }

  if (to.meta.hidden) {
    userStore.addBreadcrumbList({
      title: to.meta.title,
      path: to.path,
      name: to.name,
    });
    if (to.path === "/home/person-center") {
      to.meta.from = from.meta.from;
    }
  } else {
    const list = to.matched.reduce(
      (
        val: any[],
        item: {
          meta: {
            title: string;
          };
          path: string;
          name: string;
        }
      ) => {
        if (item.path) {
          val.push({
            title: item.meta.title,
            path: item.path,
            name: item.name,
          });
        }
        return val;
      },
      []
    );
    userStore.updateBreadcrumbList(list);
  }
});

// 用于存储用户尝试访问的路径
let pendingRoute = "";

// 在全局前置守卫中记录用户尝试访问的路径
router.beforeEach((to, from, next) => {
  pendingRoute = to.fullPath;
  next();
});

// 在路由初始化后检查是否有保存的路由
router.isReady().then(() => {
  const intendedRoute = localStorage.getItem("intendedRoute");
  if (intendedRoute) {
    router.replace(intendedRoute).then(() => {
      localStorage.removeItem("intendedRoute");
    });
  }
});

router.afterEach((to) => {
  const { userStore } = usePiniaStore();
  // 根据路由的 meta.from 更新菜单选中状态
  if (to.meta.from) {
    userStore.updateSelectMenus(to.meta.from as string);
  }
});

router.onError((error) => {
  // q:当访问了项目的某个界面（其他界面未访问，也就是未加载资源）后，重新发布项目，这时候用错误的路径去加载，然后报错。
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 使用之前记录的pendingRoute
    if (pendingRoute) {
      localStorage.setItem("intendedRoute", pendingRoute);
    }
    location.reload();
  }
});

export default router;
